 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import PAGE000 from '@/components/page000'
 import PAGE002 from '@/components/page002'
 import PAGE003 from '@/components/page003'
 import PAGE004 from '@/components/page004'
 import PAGE005 from '@/components/page005'
 import PAGE006 from '@/components/page006'
 import PAGE007 from '@/components/page007'
 import PAGE008 from '@/components/page008'
 import PAGE009 from '@/components/page009'
 import PAGE010 from '@/components/page010'
 import PAGE011 from '@/components/page011'
 import PAGE012 from '@/components/page012'
 import PAGE013 from '@/components/page013'
 import PAGE014 from '@/components/page014'
 import PAGE015 from '@/components/page015'
 import PAGE016 from '@/components/page016'
 import PAGE017 from '@/components/page017'
 import PAGE018 from '@/components/page018'
 import PAGE019 from '@/components/page019'
 import PAGE020 from '@/components/page020'
 import PAGE021 from '@/components/page021'
 import PAGE022 from '@/components/page022'
 import PAGE023 from '@/components/page023'
 import PAGE024 from '@/components/page024'
 import PAGE025 from '@/components/page025'
 import PAGE026 from '@/components/page026'
 import PAGE027 from '@/components/page027'
 import PAGE028 from '@/components/page028'
 import PAGE029 from '@/components/page029'
 import PAGE030 from '@/components/page030'
 import PAGE031 from '@/components/page031'
 import PAGE032 from '@/components/page032'
 import PAGE033 from '@/components/page033'
 import PAGE034 from '@/components/page034'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
		{
 			"path" : "/",
 			"name" : "home",
 			"components" : {
				default: Home
			}
 		},
 		{
 			"path" : "/tcpage1",
 			"name" : "tcpage1"
 			,"components" : {
				 left: PAGE000
				 ,
				 right: PAGE002
			}
 		},
 		{
 			"path" : "/tcpage2",
 			"name" : "tcpage2"
 			,"components" : {
				 left: PAGE003
				 ,
				 right: PAGE004
			}
 		},
 		{
 			"path" : "/tcpage3",
 			"name" : "tcpage3"
 			,"components" : {
				 left: PAGE005
				 ,
				 right: PAGE006
			}
 		},
 		{
 			"path" : "/tcpage4",
 			"name" : "tcpage4"
 			,"components" : {
				 left: PAGE007
				 ,
				 right: PAGE008
			}
 		},
 		{
 			"path" : "/tcpage5",
 			"name" : "tcpage5"
 			,"components" : {
				 left: PAGE009
				 ,
				 right: PAGE010
			}
 		},
 		{
 			"path" : "/tcpage6",
 			"name" : "tcpage6"
 			,"components" : {
				 left: PAGE011
				 ,
				 right: PAGE012
			}
 		},
 		{
 			"path" : "/tcpage7",
 			"name" : "tcpage7"
 			,"components" : {
				 left: PAGE013
				 ,
				 right: PAGE014
			}
 		},
 		{
 			"path" : "/tcpage8",
 			"name" : "tcpage8"
 			,"components" : {
				 left: PAGE015
				 ,
				 right: PAGE016
			}
 		},
 		{
 			"path" : "/tcpage9",
 			"name" : "tcpage9"
 			,"components" : {
				 left: PAGE017
				 ,
				 right: PAGE018
			}
 		},
 		{
 			"path" : "/tcpage10",
 			"name" : "tcpage10"
 			,"components" : {
				 left: PAGE019
				 ,
				 right: PAGE020
			}
 		},
 		{
 			"path" : "/tcpage11",
 			"name" : "tcpage11"
 			,"components" : {
				 left: PAGE021
				 ,
				 right: PAGE022
			}
 		},
 		{
 			"path" : "/tcpage12",
 			"name" : "tcpage12"
 			,"components" : {
				 left: PAGE023
				 ,
				 right: PAGE024
			}
 		},
 		{
 			"path" : "/tcpage13",
 			"name" : "tcpage13"
 			,"components" : {
				 left: PAGE025
				 ,
				 right: PAGE026
			}
 		},
 		{
 			"path" : "/tcpage14",
 			"name" : "tcpage14"
 			,"components" : {
				 left: PAGE027
				 ,
				 right: PAGE028
			}
 		},
 		{
 			"path" : "/tcpage15",
 			"name" : "tcpage15"
 			,"components" : {
				 left: PAGE029
				 ,
				 right: PAGE030
			}
 		},
 		{
 			"path" : "/tcpage16",
 			"name" : "tcpage16"
 			,"components" : {
				 left: PAGE031
				 ,
				 right: PAGE032
			}
 		},
 		{
 			"path" : "/tcpage17",
 			"name" : "tcpage17"
 			,"components" : {
				 left: PAGE033
				 ,
				 right: PAGE034
			}
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"components" : {
				default: Last
			}
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js